// Safe wrapper around window.dataLayer.push that guarantees the eventCallback
// fires exactly once, with a 2s timeout fallback when GTM is not loaded.
// Ports legacy CheckoutHelper.pushDataLayerSafe (sg-store).

interface PushDataLayerInput {
  event: string;
  value?: number;
  orderId?: string;
  eventCallback?: () => void;
}

const FALLBACK_TIMEOUT_MS = 2000;

export function pushDataLayer(input: PushDataLayerInput): void {
  const { eventCallback, ...rest } = input;

  if (!eventCallback) {
    window.dataLayer?.push({ ...rest });
    return;
  }

  let callbackInvoked = false;
  let fallbackTimerId: ReturnType<typeof setTimeout> | null = null;
  const guardedCallback = () => {
    if (callbackInvoked) return;
    callbackInvoked = true;
    if (fallbackTimerId !== null) clearTimeout(fallbackTimerId);
    eventCallback();
  };

  fallbackTimerId = setTimeout(guardedCallback, FALLBACK_TIMEOUT_MS);

  window.dataLayer?.push({ ...rest, eventCallback: guardedCallback });
}
